let language = {
    SHIPPING_TABLE_THEAD_PRODUCT: "Product",
    SHIPPING_TABLE_THEAD_COUNTRY:"Country",
    SHIPPING_TABLE_THEAD_METHOD:"Shipping Method",
    SHIPPING_TABLE_THEAD_PRICE:"Estimated price",
    SHIPPING_TABLE_THEAD_PRICE_TIP:"by quantity",
    SHIPPING_TABLE_THEAD_TIME:"Shipping Time",
    SHIPPING_TABLE_THEAD_UPDATE_QTY_BTN:"UPDATE",
    SHIPPING_TABLE_TBODY_TIME:"{{from}}-{{to}} business days"
}
export {language};